import agenticHeader from '../../components/dashboard/paywall/sales-activated-trial/page/images/agentic-header.png';
import agenticSection1 from '../../components/dashboard/paywall/sales-activated-trial/page/images/agentic-section1.png';
import agenticSection2 from '../../components/dashboard/paywall/sales-activated-trial/page/images/agentic-section2.png';
import agenticSection3 from '../../components/dashboard/paywall/sales-activated-trial/page/images/agentic-section3.png';
import agenticSection4 from '../../components/dashboard/paywall/sales-activated-trial/page/images/agentic-section4.png';
import type { PageblockData } from '../pageblockTypes';
import {
  MONITORING_PAGEBLOCK_TEXT,
  PROCESS_PAGEBLOCK_TEXT,
  DOCUMENTATION_PAGEBLOCK_TEXT,
} from '../pageblockTexts';

export const PAGEBLOCK_DATA_AGENTIC_LAYER: PageblockData = {
  headerData: {
    headerText: `Scalable systems, powered by agents`,
    subHeaderText: `Harness the power of AI agents, a dynamic visual workspace, and automated workflows. Automate processes, enforce data quality, and drive execution, all in one intelligent system.`,
    imgSrc: agenticHeader,
    imgAlt: 'Agentic Layer header',
    name: 'Agentic Layer',
  },
  pageTitle: `Stay ahead in the agentic era`,
  section1: {
    imgSrc: agenticSection1,
    imgAlt: 'Agentic Layer section img',
    title: 'Monitoring Agent',
    content: MONITORING_PAGEBLOCK_TEXT,
  },
  section2: {
    imgSrc: agenticSection2,
    imgAlt: 'Agentic Layer section 2 img',
    title: 'Process Agent',
    content: PROCESS_PAGEBLOCK_TEXT,
  },
  section3: {
    imgSrc: agenticSection3,
    imgAlt: 'Agentic Layer section 3 img',
    title: 'User Support Agent',
    content: `Reduces the time your Salesforce admin and revenue operations teams spend on support, improving SLAs and delivering a better, happier user experience.`,
  },
  section4: {
    imgSrc: agenticSection4,
    imgAlt: 'Agentic Layer section 4 img',
    title: 'Documentation Agent',
    content: DOCUMENTATION_PAGEBLOCK_TEXT,
  },
};
